(() => {
  if (customElements.get('b-marquee')) return;

  class BMarquee extends HTMLElement {
    constructor() {
      super();
      this.resizeObserver = null;
      this.rafId = 0;
      this.sectionLoadHandler = this.handleSectionLoad.bind(this);
    }

    connectedCallback() {
      this.viewport = this.querySelector('.b-marquee__viewport');
      this.track = this.querySelector('.b-marquee__track');
      this.group = this.track
        ? this.track.querySelector('.b-marquee__group')
        : null;

      document.addEventListener('shopify:section:load', this.sectionLoadHandler);

      if (!this.viewport || !this.track || !this.group) return;

      this.fill();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.scheduleFill());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
      } else {
        this.resizeHandler = () => this.scheduleFill();
        window.addEventListener('resize', this.resizeHandler, { passive: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.sectionLoadHandler);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }

      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
        this.resizeHandler = null;
      }

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = 0;
      }
    }

    scheduleFill() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        this.rafId = 0;
        this.fill();
      });
    }

    fill() {
      const groupWidth = this.group.getBoundingClientRect().width;
      const viewportWidth = this.viewport.getBoundingClientRect().width;

      if (!groupWidth || !viewportWidth) return;

      // Keep enough clones so after shifting one group, the viewport stays filled.
      const needed = Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1);

      const clones = Array.from(
        this.track.querySelectorAll('.b-marquee__group[data-marquee-clone="true"]')
      );
      const current = 1 + clones.length;

      if (current > needed) {
        clones.slice(needed - 1).forEach((node) => node.remove());
      } else if (current < needed) {
        const fragment = document.createDocumentFragment();
        for (let i = current; i < needed; i += 1) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-marquee-clone', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          fragment.appendChild(clone);
        }
        this.track.appendChild(fragment);
      }

      this.style.setProperty('--shift', `${groupWidth}px`);
      this.track.classList.add('b-marquee__track--ready');
    }

    handleSectionLoad(event) {
      if (
        event.detail &&
        event.detail.sectionId &&
        event.detail.sectionId !== this.dataset.sectionId
      ) {
        return;
      }
      this.disconnectedCallback();
      this.connectedCallback();
    }
  }

  customElements.define('b-marquee', BMarquee);
})();
